<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view :key="$route.path"></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>

    <!-- Modals -->
    <modal class="modal-danger" v-model="destroyModal" @ok="modalConfirmDestroy" effect="fade/zoom" ok-text="Delete">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Are you sure?</h4>
      </div>
      Are sure you want to delete <b>{{modalParams.name}}</b>? Please confirm.

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="destroyModal = false">Cancel</button>
        <button type="button" class="btn btn-danger" @click="modalConfirmDestroy()">Delete</button>
      </div>
    </modal>

    <modal class="modal-primary" v-model="saveModal" @ok="modalConfirmSave" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Are you sure?</h4>
      </div>
      Are sure you want to save <b>{{modalParams.name}}</b>? Please confirm.
    </modal>

    <modal class="modal" large v-model="jsonModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{modalParams.title}}</h4>
      </div>
      <pre v-highlightjs='modalParams.content'><code class="json"></code></pre>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="jsonModal = false">Close</button>
      </div>
    </modal>

    <modal class="modal-primary" v-model="alertModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{modalParams.title}}</h4>
      </div>
      {{modalParams.message}}
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="alertModal = false">Close</button>
      </div>
    </modal>

  </div>
</template>

<script>
import AppHeader from '../components/Header'
import Sidebar from '../components/Sidebar'
import AppAside from '../components/Aside'
import AppFooter from '../components/Footer'
import Breadcrumb from '../components/Breadcrumb'
import modal from 'vue-strap/src/Modal'
import {EventBus} from 'services/eventBus'

export default {
  name: 'full',
  data () {
    return {
      destroyModal: false,
      alertModal: false,
      saveModal: false,
      jsonModal: false,
      modalParams: {}
    }
  },
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    modal
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  },
  methods: {
    modalConfirmDestroy () {
      this.modalParams.confirm()
      this.destroyModal = false
    },
    modalConfirmSave () {
      this.modalParams.confirm()
      this.saveModal = false
    }
  },
  created () {
    EventBus.$on('destroy-modal', event => {
      this.modalParams = event
      this.destroyModal = true
    })

    EventBus.$on('save-modal', event => {
      this.modalParams = event
      this.saveModal = true
    })

    EventBus.$on('json-modal', event => {
      this.modalParams = event
      this.jsonModal = true
    })

    EventBus.$on('alert-modal', event => {
      this.modalParams = event
      this.alertModal = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue